<template>
  <div
    class="
      document-list-card
      mt-2
      px-4
      py-0
      flex flex-wrap
      justify-between
      text-sm
    "
    :class="{ checked: selected }"
  >
    <div class="list-item-checkbox flex" @click.stop="">
      <vs-checkbox v-model="selected" :color="AISEA_COLOR.BLUE"></vs-checkbox>
    </div>

    <!-- ファイル名 -->
    <div
      class="flex px-4 py-2 w-10/12 items-center"
      :class="fileNameClassObj"
      @click="toggleCard"
    >
      <div class="flex">
        <document-icon svgClasses="h-5 w-5" :type="fileIcon"></document-icon>
      </div>
      <div class="ml-2 flex overflow-hidden whitespace-no-wrap">
        <vx-tooltip
          :text="document.name"
          class="document-name-tooltip truncate ..."
        >
          <span>{{ document.name }}</span>
        </vx-tooltip>
      </div>
      <div>
        <awe-icon
          v-if="isStarIcon"
          name="star"
          scale="0.8"
          class="important-icon ml-1"
        />
      </div>
    </div>

    <!-- 場所 -->
    <div
      v-show="showFilePath"
      class="items-center px-4 py-2 hidden md:flex md:w-2/12"
    >
      <div class="overflow-hidden whitespace-no-wrap">
        <vx-tooltip :text="filePath" class="document-name-tooltip truncate ...">
          {{ filePath }}
        </vx-tooltip>
      </div>
    </div>

    <!-- サイズ -->
    <div
      class="
        whitespace-no-wrap
        px-4
        py-2
        align-middle
        hidden
        items-center
        md:flex md:w-2/12
      "
    >
      <span>{{ fileSize }}</span>
    </div>

    <!-- 最終更新時間 -->
    <div class="px-4 py-2 flex items-center hidden md:flex md:w-1/5">
      <span>{{ fileUpdated }}</span>
    </div>

    <!-- ドロップダウン -->
    <div class="flex justify-end w-6 py-2">
      <div v-if="!isDisabledDropdown">
        <content-dropdown
        :document="document"
        :isFolder="isFolder"
        ></content-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { DOCUMENT_KIND } from "@/config/const";
import { ColorMixin, DocumentMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import ContentDropdown from "./DocumentContentDropdown"
import DocumentIcon from "../../icon/DocumentIcon";
import { UnitUtil } from "@/utils";
import moment from "moment";


const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");


export default {
  mixins: [ColorMixin, DocumentMixin],
  components: {
    ContentDropdown,
    DocumentIcon
  },
  props: {
    document: Object,
    isFolder: Boolean
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "isSearching",
      "showListCardPath",
      "documentRootPath",
      "selectedDocuments"
    ]),
    fileNameClassObj () {
      return {
        "cursor-pointer": this.isFolder,
        'md:w-4/12': this.showFilePath,
        'md:w-6/12': !this.showFilePath
      }
    },
    selected: {
      get () {
        return this.document.selected
      },
      set (data) {
        const payload = {
          document: this.document,
          selected: data
        }
        this.SET_SELECTED_DOCUMENTS(payload);
      }
    },
    filePath () {
      if (!this.document.path) return ""
      const path = this.document.path.replace(this.documentRootPath, "")
      if (this.isFolder) return `${path}/`
      return `${path}`;
    },
    fileSize () {
      if (!this.document.size) return "";
      return UnitUtil.formatBytes(this.document.size, 0);
    },
    fileUpdated () {
      if (this.isFolder) return ""
      return moment(this.document.updated).format("YYYY-MM-DD kk:mm")
    },
    fileIcon () {
      if (this.isFolder) return DOCUMENT_KIND.FOLDER;

      return this.getDocumentMimeKind(this.document.type)
    },
    isStarIcon () {
      if (!this.document.important) return false
      return !this.isFolder && this.document.important
    },
    showFilePath () {
      return this.isSearching || this.showListCardPath
    },
    isDisabledDropdown(){
      return this.selectedDocuments.length > 0;
    }
  },
  methods: {
    ...mapMutationsOfenterpriseDocumentManager([
      "PUSH_CURRENT_PATH",
      "SET_SELECTED_DOCUMENTS",
      "RESET_DOCUMENT_SEARCH"
    ]),
    ...mapActionsOfenterpriseDocumentManager([
      "setImportantFile",
      "selectCard"
    ]),
    async toggleCard () {
      this.$vs.loading();
      if (!this.isFolder) return
      const pathItems = this.document.path.replace(this.documentRootPath, "").split("/").map(item => { return { name: item } })
      const payload = {
        pathItems: pathItems,
        path: this.document.path
      };
      await this.selectCard(payload);
      this.$vs.loading.close();
    },
    toggleAddImportant () {
      const payload = {
        path: this.document.path,
        isImportant: true
      }
      this.setImportantFile(payload)
    }
  },
  beforeDestroy () {
    document.querySelectorAll('body > div.vs-tooltip').forEach(el => {
      if (document.body.contains(el)) {
        document.body.removeChild(el);
      }
    });
  },
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

.document-name-tooltip {
  word-break: break-all;
}

.document-list-card {
  border: 1px solid $aisea-mouse-gray;
  border-radius: 4px;

  .star-icon {
    color: $aisea-blue;
  }
}

.checked {
  border: 1px solid $aisea-blue;
}
</style>